import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSeoOverride } from '../../context/SeoContext.jsx';
import { applyPageSeo } from '../../utils/seoMeta.js';

/** Aplica SEO según la ruta y cualquier override de usePageSeo en páginas de detalle. */
export default function PageSeo() {
  const { pathname } = useLocation();
  const { override } = useSeoOverride();

  useLayoutEffect(() => {
    applyPageSeo({
      pathname: override?.pathname || pathname,
      title: override?.title,
      description: override?.description,
      image: override?.image,
      noIndex: override?.noIndex,
      type: override?.type,
    });
  }, [
    pathname,
    override?.pathname,
    override?.title,
    override?.description,
    override?.image,
    override?.noIndex,
    override?.type,
  ]);

  return null;
}
